module.exports = __webpack_public_path__ + "img/sofort.5050e1a.svg";